import React, { useContext, useState } from 'react';
import { Item, Button, Label, Segment, Table, Menu, Icon, Confirm, Container, Image, Modal } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import TechnicianCertificateStore from '../../../app/stores/techniciancertificateStore';
import { Link } from 'react-router-dom';
import CertificatePhotoDropzone from '../../../app/common/Dropzone/CertificatePhotoDropzone';
import { RootStoreContext } from '../../../app/stores/rootStore';
import PhotoView from './PhotoView';

const TechnicianCertificate: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore;
  const [open, setOpen] = useState(false);
  const [technicianCertificateId, setTechnicianCertificateId] = useState("");
  const techniciancertificateStore = useContext(TechnicianCertificateStore);
  const {techniciancertificatenamesByEmail: techniciancertificatenamesByEmail,  
    deleteTechnicianCertificate: deleteTechnicianCertificate, loadTechnicianCertificatePhoto, verifyTechnicianCertificate,
     submitting, target} = techniciancertificateStore;
  return (
    <Container fluid>
      <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Name</Table.HeaderCell>
        <Table.HeaderCell>Certificate</Table.HeaderCell>
        <Table.HeaderCell>Expiry Date</Table.HeaderCell>
        <Table.HeaderCell>Verified</Table.HeaderCell>
        <Table.HeaderCell>Remark</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {techniciancertificatenamesByEmail.map(techniciancertificate => (

    <Table.Row key={techniciancertificate.id}> 
        <Table.Cell>
          <Label>{techniciancertificate.name}</Label>
        </Table.Cell>
        <Table.Cell>{techniciancertificate.certificate}</Table.Cell> 
    { (techniciancertificate.expiryDate < new Date().toISOString()) ? 
    <Table.Cell style={{backgroundColor: 'red'}}>{techniciancertificate.expiryDate.substr(8,2) + '/' +
    techniciancertificate.expiryDate.substr(5,2) + '/' + techniciancertificate.expiryDate.substr(0,4)}</Table.Cell>
     : (techniciancertificate.expiryDate < new Date(new Date().setMonth(new Date().getMonth()+3)).toISOString()) ? 
     <Table.Cell style={{backgroundColor: 'yellow'}}>{techniciancertificate.expiryDate.substr(8,2) + '/' +
     techniciancertificate.expiryDate.substr(5,2) + '/' + techniciancertificate.expiryDate.substr(0,4)}</Table.Cell> 
     : <Table.Cell>{(techniciancertificate.expiryDate) && techniciancertificate.expiryDate.substr(8,2) + '/' +
     techniciancertificate.expiryDate.substr(5,2) + '/' + techniciancertificate.expiryDate.substr(0,4)}</Table.Cell>} 
     <Table.Cell>
       { (techniciancertificate.verified === 'Y') ?  techniciancertificate.verified
         : <Button
             size='mini'
             color="blue"
             content="Verify"
             onClick={() => {
              verifyTechnicianCertificate(techniciancertificate.id);
            }}
           />
       }
     </Table.Cell> 
     <Table.Cell>{techniciancertificate.remark}</Table.Cell> 
        <Table.Cell>
        <Button.Group size='mini'>
                 {/* <Button
                  content={<CertificatePhotoDropzone name={techniciancertificate.certificate} category={techniciancertificate.name}/>}
          
                  size='mini'
                  color="grey"
         
                /> */}
                
                <Button
                  as={Link}
                  to={`/hrmanagement/techniciancertificate-edit/${techniciancertificate.id}`}
                  size='mini'
                  icon="edit"
                  color="blue"
                  title="Edit"
                />
                
                <Button
                  name={techniciancertificate.id}
                  size='mini'
                  loading={target === techniciancertificate.id && submitting}
                  onClick={() => {
                    setOpen(true);
                    setTechnicianCertificateId(techniciancertificate.id);
                  }}
                  icon="delete"
                  color="red"
                  title="Delete"
                />
                <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteTechnicianCertificate(technicianCertificateId);
                        setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
                  <Button
                  onClick={() => loadTechnicianCertificatePhoto(techniciancertificate.technicianEmail, techniciancertificate.certificateId).
                    then(() => openModal(<PhotoView certificate={techniciancertificate.certificate} name={techniciancertificate.name}
                      technicianEmail={techniciancertificate.technicianEmail} certificateId={techniciancertificate.certificateId} />))}
                  size='mini'
                  icon="picture"
                  color="green"
                  title="Photo"
                />
                  <CertificatePhotoDropzone name={techniciancertificate.certificate} category={techniciancertificate.name}/>
                  
          </Button.Group>
        </Table.Cell>
      </Table.Row> 
    ))}
    </Table.Body>
  </Table>
  
</Container>
  );
};

export default observer(TechnicianCertificate);
